/**
 * /**
 *  * Generated by orval v1.0.0 🍃
 *  * Do not edit manually.
 *  * Citrus API
 *  * API for Citrus platform
 *  *\/
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  DatabookPreloadRequest,
  DatabookPreloadResponse,
  DatabookRequest,
  DatabookUploadRequest,
  DatabookUploadResponse,
  DatasetPreloadAnalyzeResponse,
  DatasetsPreloadAnalyzeCreateParams
} from '../../models';

import { customInstance } from '../../../axios-instance';




/**
 * Upload databook excel file, Returns an array of media_channels and datasets_without_channel. Admin only.
 * @summary Preload databook
 */
export const datasetsPreloadCreate = (
    databookUploadRequest: DatabookUploadRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatabookPreloadResponse>(
      {url: `/api/datasets/preload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databookUploadRequest, signal
    },
      );
    }
  


export const getDatasetsPreloadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadCreate>>, TError,{data: DatabookUploadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadCreate>>, TError,{data: DatabookUploadRequest}, TContext> => {

const mutationKey = ['datasetsPreloadCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsPreloadCreate>>, {data: DatabookUploadRequest}> = (props) => {
          const {data} = props ?? {};

          return  datasetsPreloadCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsPreloadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsPreloadCreate>>>
    export type DatasetsPreloadCreateMutationBody = DatabookUploadRequest
    export type DatasetsPreloadCreateMutationError = unknown

    /**
 * @summary Preload databook
 */
export const useDatasetsPreloadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadCreate>>, TError,{data: DatabookUploadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsPreloadCreate>>,
        TError,
        {data: DatabookUploadRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsPreloadCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Analyze a dataset with specified action and return analysis results. Admin only.
 * @summary Analyze dataset
 */
export const datasetsPreloadAnalyzeCreate = (
    databookRequest: DatabookRequest,
    params: DatasetsPreloadAnalyzeCreateParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatasetPreloadAnalyzeResponse>(
      {url: `/api/datasets/preload/analyze`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databookRequest,
        params, signal
    },
      );
    }
  


export const getDatasetsPreloadAnalyzeCreateMutationOptions = <TError = DatasetPreloadAnalyzeResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>, TError,{data: DatabookRequest;params: DatasetsPreloadAnalyzeCreateParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>, TError,{data: DatabookRequest;params: DatasetsPreloadAnalyzeCreateParams}, TContext> => {

const mutationKey = ['datasetsPreloadAnalyzeCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>, {data: DatabookRequest;params: DatasetsPreloadAnalyzeCreateParams}> = (props) => {
          const {data,params} = props ?? {};

          return  datasetsPreloadAnalyzeCreate(data,params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsPreloadAnalyzeCreateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>>
    export type DatasetsPreloadAnalyzeCreateMutationBody = DatabookRequest
    export type DatasetsPreloadAnalyzeCreateMutationError = DatasetPreloadAnalyzeResponse

    /**
 * @summary Analyze dataset
 */
export const useDatasetsPreloadAnalyzeCreate = <TError = DatasetPreloadAnalyzeResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>, TError,{data: DatabookRequest;params: DatasetsPreloadAnalyzeCreateParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsPreloadAnalyzeCreate>>,
        TError,
        {data: DatabookRequest;params: DatasetsPreloadAnalyzeCreateParams},
        TContext
      > => {

      const mutationOptions = getDatasetsPreloadAnalyzeCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    /**
 * Upload databook, Returns an array of media_channels and datasets_without_channel. Admin only.
 * @summary Upload databook
 */
export const datasetsUploadCreate = (
    databookPreloadRequest: DatabookPreloadRequest,
 signal?: AbortSignal
) => {
      
      
      return customInstance<DatabookUploadResponse>(
      {url: `/api/datasets/upload/`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: databookPreloadRequest, signal
    },
      );
    }
  


export const getDatasetsUploadCreateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsUploadCreate>>, TError,{data: DatabookPreloadRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof datasetsUploadCreate>>, TError,{data: DatabookPreloadRequest}, TContext> => {

const mutationKey = ['datasetsUploadCreate'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof datasetsUploadCreate>>, {data: DatabookPreloadRequest}> = (props) => {
          const {data} = props ?? {};

          return  datasetsUploadCreate(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DatasetsUploadCreateMutationResult = NonNullable<Awaited<ReturnType<typeof datasetsUploadCreate>>>
    export type DatasetsUploadCreateMutationBody = DatabookPreloadRequest
    export type DatasetsUploadCreateMutationError = unknown

    /**
 * @summary Upload databook
 */
export const useDatasetsUploadCreate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof datasetsUploadCreate>>, TError,{data: DatabookPreloadRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof datasetsUploadCreate>>,
        TError,
        {data: DatabookPreloadRequest},
        TContext
      > => {

      const mutationOptions = getDatasetsUploadCreateMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    